import React, { createContext, type ReactNode, useContext } from 'react'
import { useContainerWidth } from '@fs/zion-ui'

const MergeLayoutContext = createContext<boolean | null>(null)

type Props = {
  children: ReactNode
}

/**
 * Measures the page-level container once so every merge component reads the same isMobile value. Calling
 * useContainerWidth deeper in the tree would misreport: cells of InBetweenBorderGrid/InBetweenSeparatorGrid mount
 * their own ResponsiveProviders (a half-width column reads as mobile at desktop), and the sticky headers render
 * through a portal. Mount above the merge grids, where the nearest ResponsiveProvider is the page itself.
 */
export default function MergeLayoutProvider({ children }: Props): JSX.Element {
  const isMobile = useContainerWidth()({ default: true, lg: false })

  return <MergeLayoutContext.Provider value={isMobile}>{children}</MergeLayoutContext.Provider>
}

/** Defaults to desktop (false) when no MergeLayoutProvider is mounted, e.g. the old-design post-merge V1 pages. */
export function useMergeIsMobile(): boolean {
  return useContext(MergeLayoutContext) ?? false
}
